import React, { useState } from 'react';

import { Container } from '@nivo/core';
import { useHistory } from 'react-router';
import {
  PageContainer,
  Button,
  majorScale,
  Card,
  Grid,
  Heading,
  FormField,
  useToast,
} from '../../npaper';
import Box from 'ui-box';
import { FileInput } from '../../npaper/FileInput';
import { FormattedMessage, useIntl } from 'react-intl';
import { useStores } from '../../stores';

const TermsPage = () => {
  const history = useHistory();
  const toaster = useToast();
  const intl = useIntl();
  const { organisationStore, authStore } = useStores();

  const [uploadFile, setUploadFile] = useState<File>();

  const uploadTermsPDF = async () => {
    if (!uploadFile) {
      toaster.addToast({
        intent: 'warning',
        message: intl.formatMessage({
          defaultMessage: 'You must select a PDF to upload',
        }),
      });
      return;
    }

    try {
      await organisationStore.updateTermsPDF(
        authStore.currentOrganisation!,
        uploadFile
      );
      toaster.addToast({
        intent: 'success',
        message: intl.formatMessage({
          defaultMessage: 'PDF file has been uploaded',
        }),
      });
    } catch (error) {
      toaster.showDefaultError(error);
    }
  };

  return (
    <PageContainer>
      <Container>
        <Button
          iconLeft="arrow-left"
          marginBottom={majorScale(2)}
          onClick={() =>
            history.length > 0 ? history.goBack() : history.push('/settings')
          }
        >
          Indstillinger
        </Button>

        <Grid>
          <Card className="col-span-12 md:col-span-12 lg:col-span-10 xl:col-span-8">
            <div className="dialog">
              <Box className="header">
                <Heading size={400}>Salgs- og leveringsbetingelser</Heading>
              </Box>
              <Grid padding={majorScale(2)}>
                <Heading size={300} className="col-span-12">
                  Dokumenter
                </Heading>

                <FormField
                  className="col-span-9"
                  label="Salgsbetingelser"
                  inline
                  center
                >
                  <FileInput
                    placeholder={
                      authStore.currentOrganisation!.terms_pdf
                        ? authStore
                            .currentOrganisation!.terms_pdf.split('/')
                            .pop()
                        : 'Upload PDF med betingelser'
                    }
                    accept="application/pdf"
                    onSelectFile={(file) => setUploadFile(file)}
                  />
                </FormField>

                <p className="col-span-5 col-start-4 small muted">
                  Du kan vælge at uploade dine salgs- og leveringsbetingelser
                  som en PDF. Når du laver et tilbud, en ordre eller en faktura
                  bliver PDF'en helt automatisk kædet ind i dokumentet.
                </p>
              </Grid>
              <Box className="actions">
                <Button
                  onClick={() =>
                    history.length > 0
                      ? history.goBack()
                      : history.push('/settings')
                  }
                >
                  <FormattedMessage
                    id="defaults.cancel"
                    defaultMessage="Cancel"
                  />
                </Button>
                <Button primary onClick={() => uploadTermsPDF()}>
                  <FormattedMessage
                    id="defaults.save-changes"
                    defaultMessage="Save changes"
                  />
                </Button>
              </Box>
            </div>
          </Card>
        </Grid>
      </Container>
    </PageContainer>
  );
};

export default TermsPage;
